import { AUTHENTICATION_URL_PARAMS, } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import AlternateAuthenticationWrapper from './AlternateAuthenticationWrapper';
import { Auth0Provider } from '../Auth0/';
import AuthenticationWrapper from './AuthenticationWrapper';
import { ForgeProvider } from '../Forge';
import { LoginDomainPromptProvider } from '@innovyze/stylovyze/lib/components';
import { RegionPickerPromptProvider } from '@innovyze/stylovyze/lib/components/RegionPickerPrompt/RegionPickerPromptProvider';
import ScrollToTop from '@innovyze/stylovyze/lib/utils/ScrollToTop';
import { ExitToApp } from '@mui/icons-material';
import { StyledLink } from '../../components/LoginDomainPrompt/LoginDomainPrompt.styles';
const AuthenticationRouter = ({ children, hasLoginPicker = false, authenticate = false, hasSharedWorkers, }) => {
    useEffect(() => {
        if (hasLoginPicker)
            console.warn('LOGIN_V2 enabled');
        else
            console.warn('LOGIN_V2 disabled');
    }, [hasLoginPicker]);
    // Only fall into the AuthenticationWrapper when hasLoginPicker is falsy
    // When set, hasLoginPicker could be forcing a particular AuthType (Forge / Auth0) or allowing them both (true)
    if (!hasLoginPicker) {
        return (React.createElement(AuthenticationWrapper, { authenticate: authenticate, hasLoginPicker: hasLoginPicker, hasSharedWorkers: hasSharedWorkers },
            React.createElement(React.Fragment, null, children)));
    }
    const isAuth0Route = window.location.pathname.includes(AUTHENTICATION_URL_PARAMS.AUTH0);
    const authenticationPages = [
        {
            path: AUTHENTICATION_URL_PARAMS.PICKER,
            to: AUTHENTICATION_URL_PARAMS.PICKER,
            render: React.createElement(LoginDomainPromptProvider, null),
        },
        {
            path: AUTHENTICATION_URL_PARAMS.AUTH0,
            to: AUTHENTICATION_URL_PARAMS.AUTH0,
            render: (React.createElement(Auth0Provider, { options: {
                    forceLogin: isAuth0Route,
                    authenticate,
                    redirectUri: window.location.origin,
                }, hasSharedWorkers: hasSharedWorkers },
                React.createElement(React.Fragment, null, children))),
        },
        {
            path: AUTHENTICATION_URL_PARAMS.AUTODESK,
            to: AUTHENTICATION_URL_PARAMS.AUTODESK,
            render: (React.createElement(ForgeProvider, { options: {
                    forceLogin: true,
                    authenticate,
                    redirectUri: window.location.origin + '/auth/forge/login',
                }, hasSharedWorkers: hasSharedWorkers },
                React.createElement(React.Fragment, null, children))),
        },
        {
            path: AUTHENTICATION_URL_PARAMS.REGION_PICKER,
            to: AUTHENTICATION_URL_PARAMS.REGION_PICKER,
            render: (React.createElement(RegionPickerPromptProvider, { options: {
                    forceLogin: true,
                    authenticate,
                    redirectUri: window.location.origin + '/auth/forge/login',
                } })),
        },
        {
            path: '*',
            to: '*',
            render: (React.createElement(AlternateAuthenticationWrapper, { authenticate: authenticate, hasLoginPicker: hasLoginPicker, hasSharedWorkers: hasSharedWorkers }, children)),
        },
    ];
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: '/login/automation' },
            React.createElement(StyledLink, { "data-cy": 'go-to-app', to: '/', style: { display: 'flex', alignItems: 'center' } },
                'Go to app ',
                React.createElement(ExitToApp, null))),
        authenticationPages.map(({ path, to, render }, i) => (React.createElement(Route, { key: i, exact: true, path: path || to },
            React.createElement(ScrollToTop, { elementId: 'main' }),
            render)))));
};
export default AuthenticationRouter;
